import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export const FAQItem: React.FC<FAQItemProps> = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#742EFF]/20 last:border-0 bg-gradient-to-br from-[#0A1BFF]/10 to-[#742EFF]/10 backdrop-blur-sm rounded-lg mb-2" data-id="element-59">
      <button onClick={() => setIsOpen(!isOpen)} className="flex justify-between items-center w-full py-4 sm:py-6 px-4 sm:px-6 text-left" data-id="element-60">
        <h3 className="text-base sm:text-lg md:text-xl font-medium text-[#F5F5F7] pr-2" data-id="element-61">
          {question}
        </h3>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 ml-2 sm:ml-4" data-id="element-62">
          <ChevronDownIcon className="w-5 h-5 sm:w-6 sm:h-6 text-[#AE00FF]" data-id="element-63" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-64">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-65">
            <div className="pb-4 sm:pb-6 px-4 sm:px-6 text-[#F5F5F7]/80 whitespace-pre-line text-sm sm:text-lg" data-id="element-66">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};